module.exports = __webpack_public_path__ + "static/media/image5.8d16c4af.jpg";